export const getDefaultBrowseVendors = () => ({
  is_active: true,
  title: 'Food & Drinks',
  location: {
    key: 'location',
    title: 'Location',
    placeholder: 'All Levels',
    levels: []
  },
  cuisine: {
    key: 'cuisine',
    title: 'Cuisine',
    placeholder: 'All Cuisines',
    options: []
  },
  dietary: {
    key: 'dietary',
    title: 'Dietary Preferences',
    placeholder: 'No Dietary Preferences',
    options: []
  },
  vendors: []
})

export const mergeBrowseVendors = (browseVendors = {}) => ({
  ...getDefaultBrowseVendors(),
  ...browseVendors
})
